import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {PartnerService} from '../partner/partner.service';
import {SegmentService} from '../segment/segment.service';
import {DistributionAccountCreateComponent} from './create/create.component';
import {DistributionAccountService} from './distribution-account.service';

@Component({
  selector: 'app-distribution-accounts',
  styles: [':host {display: block; position: relative; width: 100%;}'],
  template: `
    <app-distribution-accounts-list (showCreateDialog)="showCreateDialog()">
    </app-distribution-accounts-list>`
})
export class DistributionAccountComponent implements OnInit {
  private config!: MatDialogConfig;

  createDialogRef!: MatDialogRef<DistributionAccountCreateComponent>;

  constructor(private dialog: MatDialog,
              private segmentsActions: SegmentService,
              private distributionAccountsActions: DistributionAccountService,
              private partnerActions: PartnerService) {
  }

  ngOnInit() {
    this.partnerActions.getPartnerList();
    this.segmentsActions.getSegmentList();
    this.distributionAccountsActions.fetchTargetSystemsWithDistributionAccounts();
  }

  showCreateDialog() {
    this.createDialogRef = this.dialog.open(DistributionAccountCreateComponent, this.config);
    this.createDialogRef.afterClosed().subscribe(() => this.distributionAccountsActions.fetchTargetSystemsWithDistributionAccounts());
  }
}
